/* Bastion Collective — theme behavior.
   Replaces support.js (the Claude design-canvas React runtime), which required
   window.React and never initialized on the storefront. Everything here is
   plain, dependency-free JS. */

(function () {
  'use strict';

  /* Accordion: allow only one FAQ item open at a time within a group. */
  function initAccordions(scope) {
    var groups = (scope || document).querySelectorAll('[data-accordion]');
    Array.prototype.forEach.call(groups, function (group) {
      if (group.dataset.accordionReady === 'true') return;
      group.dataset.accordionReady = 'true';

      var items = group.querySelectorAll('details.bkc-accordion__item');
      Array.prototype.forEach.call(items, function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          if (group.dataset.accordion !== 'single') return;
          Array.prototype.forEach.call(items, function (other) {
            if (other !== item) other.open = false;
          });
        });
      });
    });
  }

  /* Smooth scroll for in-page anchors, respecting reduced-motion. */
  function initAnchors() {
    if (document.documentElement.dataset.anchorsReady === 'true') return;
    document.documentElement.dataset.anchorsReady = 'true';

    document.addEventListener('click', function (event) {
      var link = event.target.closest('a[href^="#"]');
      if (!link) return;

      var id = link.getAttribute('href');
      if (!id || id === '#') return;

      var target = document.querySelector(id);
      if (!target) return;

      event.preventDefault();
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
    });
  }

  function init(scope) {
    initAccordions(scope);
    initAnchors();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  /* Re-initialize when the theme editor re-renders a section. */
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();

/* ---------------------------------------------------------------------------
   Product page behavior: variant switching and gallery thumbnails.
   Added alongside the block-based product section.
   --------------------------------------------------------------------------- */
(function () {
  'use strict';

  function initProductGallery(scope) {
    var root = scope || document;
    var main = root.querySelector('[data-gallery-main]');
    if (!main) return;

    root.addEventListener('click', function (event) {
      var thumb = event.target.closest('[data-gallery-thumb]');
      if (!thumb) return;
      var full = thumb.getAttribute('data-full');
      if (!full) return;
      main.setAttribute('src', full);
      root.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
        t.classList.toggle('is-active', t === thumb);
      });
    });
  }

  function initVariants(scope) {
    var root = scope || document;
    var selects = root.querySelectorAll('[data-variant-option]');
    if (!selects.length) return;

    var dataEl = root.querySelector('[data-product-variants]');
    if (!dataEl) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    function currentOptions() {
      var values = [];
      root.querySelectorAll('select[data-variant-option]').forEach(function (s) {
        values[parseInt(s.dataset.optionPosition, 10) - 1] = s.value;
      });
      root.querySelectorAll('input[data-variant-option]:checked').forEach(function (r) {
        values[parseInt(r.dataset.optionPosition, 10) - 1] = r.value;
      });
      return values;
    }

    function update() {
      var chosen = currentOptions();
      var match = variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === chosen[i]; });
      });

      root.querySelectorAll('.bkc-variant-pill').forEach(function (pill) {
        var input = pill.querySelector('input');
        pill.classList.toggle('is-selected', input && input.checked);
      });

      if (!match) return;

      var idInput = root.querySelector('[data-variant-id]');
      if (idInput) idInput.value = match.id;

      var button = root.querySelector('button[name="add"]');
      if (button) {
        button.disabled = !match.available;
        var label = button.getAttribute(match.available ? 'data-label-available' : 'data-label-sold-out');
        if (label) button.textContent = label;
      }

      if (match.featured_image && match.featured_image.src) {
        var main = root.querySelector('[data-gallery-main]');
        if (main) main.setAttribute('src', match.featured_image.src);
      }

      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        history.replaceState({}, '', url.toString());
      }
    }

    root.addEventListener('change', function (event) {
      if (event.target.matches('[data-variant-option]')) update();
    });
    update();
  }

  function boot(scope) {
    initProductGallery(scope);
    initVariants(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

/* ---------------------------------------------------------------------------
   Collection filtering and sorting.
   The form works without JavaScript via its Apply button. When JS is present
   and the section is set to auto-apply, we submit on change and hide the button.
   --------------------------------------------------------------------------- */
(function () {
  'use strict';

  function initCollectionControls(scope) {
    var forms = (scope || document).querySelectorAll('#CollectionControls, .bkc-collection-controls');

    Array.prototype.forEach.call(forms, function (form) {
      if (form.dataset.controlsReady === 'true') return;
      form.dataset.controlsReady = 'true';

      if (form.dataset.autoSubmit !== 'true') return;
      form.classList.add('js-auto-submit');

      var debounce;
      form.addEventListener('change', function (event) {
        if (!event.target.matches('[data-filter-input]')) return;

        // Price inputs are typed, so wait for a pause before submitting.
        if (event.target.type === 'number') {
          clearTimeout(debounce);
          debounce = setTimeout(function () { form.submit(); }, 600);
        } else {
          form.submit();
        }
      });

      // Let Enter in a price field apply immediately.
      form.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' && event.target.type === 'number') {
          clearTimeout(debounce);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initCollectionControls(document); });
  } else {
    initCollectionControls(document);
  }
  document.addEventListener('shopify:section:load', function (e) { initCollectionControls(e.target); });
})();
